import React from 'react';

export default function AgeGateDeniedBottomSheet({ label = '18+', onDismiss, onExplore }) {
  return (
    <div onClick={onDismiss} style={S.backdrop} role="presentation">
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Age restricted event"
        style={S.sheet}
      >
        {/* Header */}
        <div style={S.header}>
          <div style={S.headerTitle}>Age Restricted</div>
        </div>

        {/* Body */}
        <div style={S.body}>
          <div style={S.illustration} aria-hidden>
            <div style={{ fontSize: 56, fontWeight: 900 }}>🔞</div>
          </div>

          <div style={S.section}>
            <div style={S.headline}>This event is <b>{label}</b></div>
            <div style={S.subheading}>
              You don’t meet the age requirement for this event.
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={S.footer}>
          <div style={S.footerRow}>
            <button type="button" onClick={onExplore} style={S.secondaryBtn}>
              Explore other events
            </button>
            <button type="button" onClick={onDismiss} style={S.primaryBtn}>
              OK
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp { from { transform: translateY(16px); opacity:0 } to { transform: translateY(0); opacity:1 } }
        @media (prefers-reduced-motion: reduce) { * { animation: none !important; transition: none !important } }
        button:focus-visible { outline: 0; box-shadow: 0 0 0 3px rgba(59,130,246,.45) }
      `}</style>
    </div>
  );
}

const S = {
  backdrop: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.40)', zIndex: 9999,
    display: 'flex', justifyContent: 'center', alignItems: 'flex-end', padding: 8,
    fontFamily: "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  sheet: {
    width: '100%', maxWidth: 520, background: '#fff', borderRadius: 12,
    boxShadow: '0 8px 28px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column',
    animation: 'slideUp .25s ease-out', overflow: 'hidden',
  },
  header: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    height: 48, padding: '0 16px', borderBottom: '1px solid #eef0f2',
  },
  headerTitle: { fontSize: 14, fontWeight: 800, color: '#0b0b0b', letterSpacing: '-0.01em' },
  body: { maxHeight: 'min(64vh, 560px)', overflow: 'auto', padding: '8px 12px 12px', display: 'flex', flexDirection: 'column', gap: 12 },
  section: { background: '#fff' },
  illustration: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    height: 200, marginTop: 4, marginBottom: 6, border: '1px dashed #eef0f2',
    borderRadius: 12, background: '#fafafa',
  },
  headline: { fontSize: 16, fontWeight: 900, color: '#0b0b0b', margin: '2px 2px 6px' },
  subheading: { fontSize: 13.5, color: '#374151', lineHeight: 1.55, margin: '0 2px 6px' },
  footer: { padding: 12, borderTop: '1px solid #eef0f2' },
  footerRow: { display: 'flex', gap: 8 },
  secondaryBtn: {
    flex: 1, background: '#fff', color: '#0b0b0b', border: '1px solid #e5e7eb',
    borderRadius: 10, padding: '12px 14px', fontSize: 13, fontWeight: 800, cursor: 'pointer',
  },
  primaryBtn: {
    flex: 1, background: '#000', color: '#fff', border: '1px solid #000',
    borderRadius: 10, padding: '12px 14px', fontSize: 13, fontWeight: 800, cursor: 'pointer',
  },
};
